import styled from 'styled-components';
import {Button} from 'global/styles/styles.js';
const S = {};

S.AccountHistoryBonus = styled.div`
    width: calc(100% - 2rem);
    padding: 0 1rem;
`;

S.Table = styled.table`
    margin-bottom: 1.25rem;
    margin-top: 0;
    width: 100%;
    border-spacing: 0;
    border-collapse: collapse;
`;

S.Thead = styled.thead`
    .historyHeader {
        height: 2rem;
        border-bottom: 2px solid #C62828;
    }
`;

S.Tbody = styled.tbody`
    &:before {
        content:"@";
        display:block;
        line-height: 1.1667rem;
        text-indent: -99999px;
    }
    &.test {
        column-span: 2;
    }
`;

S.Tr = styled.tr`
    border-top: 0;
    background-color: #fff;

    &.activeHeader {
        height: 3.1667rem;
    }

    &:before,
    &:after {
        display: none !important;
    }

    &.spacer {
        display: block;
        height: 6px;
        background: none;
    }

    &.tableSeparator {
        display: block;
        height: 2px;
        background: none;
    }

    &.offerRow {
        & .offerStatus {
            width: 100%;
            height: 19px;
            padding: 0 1.25rem;
            font-size: 10px;
            font-weight: 600;
            color: #000;
            vertical-align: middle;
            text-align: center;
            background-color: ${({theme:{$accountProfileBonusTabActiveBonusRowBg}})=> $accountProfileBonusTabActiveBonusRowBg};
            border-radius: 3px;
        }
    }   
`;

S.Td = styled.td`
    height: 3.25rem;
    font-size: 0.625rem;
    margin-bottom: 0.1875rem;
    border-radius: 0.1875rem;
    background-color: ${({theme:{$accountProfileBonusTabActiveBonusRowBg}})=> $accountProfileBonusTabActiveBonusRowBg};
   
    &.activeBonusRowDate {
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: center;
    }

    &.amountRow {
        text-align: center;
    }

    &.bonus-actions {
        text-align: center;
        span {
            display: block;
            padding: 0;
            line-height: 2rem;
            text-align: center;
            color: #fff;
            border-radius: 5px;
            height: 100%;
            border: 0;
            box-sizing: border-box;
            width: 100%;
            margin: 5px 0;
            background-size: 24px 24px;
            height: 24px;
            &.negative,
            &.positive {
                border-radius: 20px;
                background: none;
            }
            &.positive{
                & .a {
                    fill: ${({theme:{$accountProfileBonusTabActiveBonusCheckIconBg}})=> $accountProfileBonusTabActiveBonusCheckIconBg};
                }
                & .b {
                    fill: ${({theme:{$accountProfileBonusTabActiveBonusCheckIconSign}})=> $accountProfileBonusTabActiveBonusCheckIconSign};   
                }
            }
            &.negative{
                & .a {
                    fill: ${({theme:{$accountProfileBonusTabActiveBonusCanceledIcon}})=> $accountProfileBonusTabActiveBonusCanceledIcon};
                }
                & .b {
                    fill: none;
                }
            }
        }
    }
    &.pagination {
        background-color: #EFF2F3;
    }
        &.wageredPercent {
        width: 15%;
    }
    &:first-child {
        width: 40%;
        padding-left: 0.75rem;
        padding-right: 0.625rem;
        font-weight: 700;
        text-align: left;
        font-size: 0.8125rem;
        border-top-left-radius: 0.25rem;
        border-bottom-left-radius: 0.25rem;
    }
    &:last-child {
        width: 8%;
        border-top-right-radius: 0.4167rem;
        border-bottom-right-radius: 0.4167rem;
    }

    &.noResults {
        background-color: none;
        text-align: center;
    }
`;

S.Th = styled.th`  
    background-color: ${({theme:{$accountProfileBonusTabActiveHeaderBg}})=> $accountProfileBonusTabActiveHeaderBg};
    color: ${({theme:{$accountProfileBonusTabActiveHeaderTxt}})=> $accountProfileBonusTabActiveHeaderTxt};
    padding: 0 1.1rem;
    font-size: 0.625rem;
    font-weight: 400;
    vertical-align: center;
    text-align: center;
    border-top: 0;

    &:first-child {
        width: 40%;
    }
    &:nth-child(4) {
        width: 18%;
    }
`;

S.BonusList = styled.div`
    display: flex;
    justify-content: center;
`;


S.NoResult = styled.tr`
    height: 2.5rem;
    text-align: center;
`;

S.Button = styled(Button)`
    display: block;
    padding: 0;
    line-height: 2rem;
    text-align: center;
    color: #fff;
    border-radius: 5px;
    height: 100%;
    border: 0;
    box-sizing: border-box;
    width: 100%;
    margin: 5px 0;
    background-size: 24px 24px;
    height: 24px;

    &.reject {
        height: 2rem;
        width: 2rem;
        border-radius: 20px;
        background: none;
        & .a {
            fill: ${({theme:{$accountProfileBonusTabActiveBonusCancelBg}})=> $accountProfileBonusTabActiveBonusCancelBg};
        }
        & .b {
            fill: none;
        }
    }
    &.accept {
        background-color: #00a651;
    }
`;

S.ActivateModal = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
    margin-top: -30px;
`;

S.BtnsWrapper = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
`;

S.ButtonCancel = styled(Button)`
    color: #fff;
    border: none;
    border-radius: 3px;
    box-shadow: none;
    padding: 6px 12px;
    background: #00a651;
    margin-right: 1rem;
    margin-top: 1rem;
`;
S.ButtonAccept = styled(S.ButtonCancel)``;

S.Title = styled.div`
    font-size: 1.2307692308rem;
    letter-spacing: .5px;
    font-weight: 600;
    line-height: 2rem;
    text-align: center;
`;

S.Description = styled.div`
    text-align: center;
`;

S.ProgressLineWrapper = styled.div`
    width: 100%;
    margin: 0 auto;
`;
export default S;